// Minimum versions that support CSS cascade layers
const BROWSERSLIST = {
  CHROME: '99',
  SAFARI: '15.4',
  FIREFOX: '97',
  IOS: '15.4',
};

export default BROWSERSLIST;
